import { render } from "./SidebarListItem.vue?vue&type=template&id=664719f1&bindings={}"
import script from "./SidebarListItem.vue?vue&type=script&lang=ts"
export * from "./SidebarListItem.vue?vue&type=script&lang=ts"

import "./SidebarListItem.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script